import React from "react";
import { useMediaQuery } from "react-responsive";
import { QuestionTitle } from "../../components/QuestionTitle";
import { Flex, Title } from "../../styles/common";
import { theme } from "../../styles/theme";

export const AdminGenerateOrders = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`,
  });

  return (
    <Flex direction="column">
      <QuestionTitle />
      <Title>
        <img
          alt="Ordenes-de-compra-generadas"
          src="https://6957948.fs1.hubspotusercontent-na1.net/hubfs/6957948/Ordenes-de-compra-generadas.jpg"
          width={isMobile ? "100%" : "688px"}
        />
      </Title>
      <Title style={{ textAlign: "center" }}>
        ¡Mira este video y conoce el paso a paso
      </Title>
      <Title style={{ textAlign: "center" }}>
        para administrar tus órdenes de compra!
      </Title>
      <div
        class="hs-embed-wrapper"
        style={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          height: "auto",
          padding: "0px",
          maxWidth: "688px",
          maxHeight: "388.72px",
          minWidth: "256px",
          display: "block",
          margin: "auto",
        }}
        data-service="youtube"
        data-responsive="true"
      >
        <div class="hs-embed-content-wrapper">
          <div
            style={{
              position: "relative",
              overflow: "hidden",
              maxWidth: "100%",
              paddingBottom: "56.5%",
              margin: "0px",
            }}
          >
            <iframe
              title="generate-orders"
              width="200"
              height="113"
              src="https://www.youtube.com/embed/2GrC2L63898?feature=oembed"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""
              style={{
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          </div>
        </div>
      </div>
    </Flex>
  );
};
